/**
 * No particular endpoint exists for this model-type.  This is a convenience model for
 * accessing data from within a Locale model.
 */
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import Format from 'app/src/data/Format';

export default class CurrencyDenomination extends RetailModel {
  // Server uses the currencyDenominationID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'currencyDenominationID';
  }

  get defaults() {
    return {
      name: '',
      value: '',
      significant: false,
    };
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    let parsedResponse;
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    if (response.CurrencyDenomination) {
      parsedResponse = response.CurrencyDenomination;
    } else {
      parsedResponse = response;
    }

    return parsedResponse;
  }
}
